import {useEffect} from "react";
import setKeyboardSizeLogic from "../../../services/onboarding/setKeyboardSizeLogic";
import {IKeyboardConnectionHelpProps, useKeyboardConnectionHelp} from "./useKeyboardConnectionHelp.hook";

export interface ISetKeyboardSizeLogic {
  keyboardConnectionHelp: IKeyboardConnectionHelpProps,
}

export const useSetKeyboardSizeLogic = (): ISetKeyboardSizeLogic => {
  // Over time, we can move the contents of setKeyboardSizeLogic.ts into this file.
  // We can also pull logic from the SetKeyboardSize.tsx component into this file.
  const keyboardConnectionHelp = useKeyboardConnectionHelp();

  useEffect(() => {
    setKeyboardSizeLogic.setUpTheKeyboard();

    return () => {
      setKeyboardSizeLogic.destroy();
    }
  }, []);

  return {
    keyboardConnectionHelp,
  };
}
